export default "__VITE_ASSET__C8m_dq0d__"